module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/btn_1_sp_41124b15acdf9947a58885c67ee98866.png";